export default{
    contactLinkFailed(state){
        return state.contactLinkFailed
    },
    contactLinkSuccess(state){
        return state.contactLinkSuccess
    }
}